/* Shared helpers for the province shipping-fee "brick" line.

   On the standard Shopify plan the checkout is not editable and there is no
   native way to add an arbitrary fee, so the province charge (entablado +
   envío a la agencia) is collected as a real line item: a S/1.00 product added
   with quantity = amount in soles. Because it is a real line, it inflates
   cart.item_count and would show up as a normal product — every badge, count
   and cart render must exclude it. These helpers are the single source of truth
   for "which line is the fee" and "how many real product units are there".

   The fee variant id is injected once, inline in the <head> of theme.liquid,
   from settings.shipping_fee_product. When the merchant has not picked the fee
   product yet, VLX_FEE_VARIANT is null and every helper degrades to plain cart
   figures, so the store works normally before the brick product exists. */
(function () {
  window.VLX = window.VLX || {};

  function feeVariant() {
    var v = window.VLX_FEE_VARIANT;
    return (typeof v === 'number' && v > 0) ? v : null;
  }

  function feeLine(cart) {
    var id = feeVariant();
    if (!id || !cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === id) return cart.items[i];
    }
    return null;
  }

  // Real product units in the cart (sum of quantities, excluding the fee brick).
  function units(cart) {
    if (!cart || !cart.items) return 0;
    var id = feeVariant(), n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id !== id) n += it.quantity;
    }
    return n;
  }

  // cart.item_count minus the fee brick's quantity — what every badge should show.
  function realCount(cart) {
    if (!cart) return 0;
    var line = feeLine(cart);
    return cart.item_count - (line ? line.quantity : 0);
  }

  window.VLX.feeVariant = feeVariant;
  window.VLX.feeLine = feeLine;
  window.VLX.units = units;
  window.VLX.realCount = realCount;
})();
